import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IExam, IExaminationExaminer } from 'src/app/interface/dto';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-add-examiner',
  templateUrl: './add-examiner.component.html',
  styleUrls: ['./add-examiner.component.scss']
})
export class AddExaminerComponent implements OnInit, OnChanges {

  examinationExaminer: IExaminationExaminer = {
    examinationID: 0,
    user: '',
    id: 0
  }
  @Input() selecetedExaminer: IExaminationExaminer = {} as IExaminationExaminer;
  exam: IExam = examDefault;

  users: any[] = [];
  text = 'Add';

  constructor(private examsevice: ExamService, private snackBar: SnackbarService, private cdr: ChangeDetectorRef, private evnt: EventService) { }

  async ngOnInit() {
    this.exam = this.examsevice.selectedExams[0];
    this.examinationExaminer.examinationID = this.exam.id;
    this.examsevice.getUsers().then((res: any) => {
      if (res) {
        this.users = res.data;
      }
    });
  }
  async ngOnChanges(changes: SimpleChanges) {
    if (changes['selecetedExaminer'] && changes['selecetedExaminer'].currentValue) {
      this.examinationExaminer = { ...changes['selecetedExaminer'].currentValue };
      if (this.examinationExaminer.id && this.examinationExaminer.id != 0) {
        this.text = 'Update';
      } else {
        this.text = 'Add';
      }

    }
    console.log(this.examinationExaminer, 'examiner');

    this.cdr.detectChanges();
  }
  addExaminer() {
    this.examinationExaminer = {
      examinationID: this.exam.id,
      user: '',
      id: 0
    };
    this.text = 'Add';
  }
  async saveExaminer() {
    try {
      await this.examsevice.saveExaminationExaminer(this.examinationExaminer).then((res: any) => {
        if (res) {
          this.snackBar.success('Examiner updated successfully');
          this.examinationExaminer = {} as IExaminationExaminer;
          this.text = 'Add';
          this.evnt.addExaminerMessageEvent.emit('refreshCategory');

        }
      });

    } catch (error) {
      this.snackBar.error('Failed to update examiner: ' + error);
    }
  }
}
